import React from "react";
import DocumentVenteEntity from "./DocumentVenteEntity";

const BonCommandeVente = () => {
    return <DocumentVenteEntity type="Bon Commande" title="Bons Commande" endpoint="BonCommandeVente" />;
};

export default BonCommandeVente;
